import { getApp, getApps, initializeApp } from "firebase/app";
import { getAnalytics, isSupported as analyticsIsSupported } from "firebase/analytics";

function readEnv(key) {
  const env = typeof process !== "undefined" && process?.env ? process.env : {};
  return String(env[key] || "").trim();
}

const firebaseConfig = {
  apiKey: readEnv("REACT_APP_FIREBASE_API_KEY"),
  authDomain: readEnv("REACT_APP_FIREBASE_AUTH_DOMAIN"),
  projectId: readEnv("REACT_APP_FIREBASE_PROJECT_ID"),
  storageBucket: readEnv("REACT_APP_FIREBASE_STORAGE_BUCKET"),
  messagingSenderId: readEnv("REACT_APP_FIREBASE_MESSAGING_SENDER_ID"),
  appId: readEnv("REACT_APP_FIREBASE_APP_ID"),
  measurementId: readEnv("REACT_APP_FIREBASE_MEASUREMENT_ID"),
};

function hasRequiredFirebaseConfig() {
  return Boolean(firebaseConfig.apiKey && firebaseConfig.projectId && firebaseConfig.appId);
}

function isFirebaseAnalyticsEnabled() {
  const raw = readEnv("REACT_APP_ENABLE_FIREBASE_ANALYTICS").toLowerCase();
  return raw === "1" || raw === "true" || raw === "yes" || raw === "on";
}

let analyticsPromise = null;

export function initFirebaseApp() {
  if (typeof window === "undefined") return null;
  if (!hasRequiredFirebaseConfig()) return null;
  if (getApps().length) return getApp();
  return initializeApp(firebaseConfig);
}

export function initFirebaseAnalytics() {
  if (typeof window === "undefined") return Promise.resolve(null);
  if (!isFirebaseAnalyticsEnabled()) return Promise.resolve(null);
  if (analyticsPromise) return analyticsPromise;

  analyticsPromise = (async () => {
    try {
      const app = initFirebaseApp();
      if (!app) return null;
      const supported = await analyticsIsSupported();
      if (!supported) return null;
      return getAnalytics(app);
    } catch {
      return null;
    }
  })();

  return analyticsPromise;
}

export function isFirebaseConfigured() {
  return hasRequiredFirebaseConfig();
}

export { firebaseConfig };
